import { render } from "./CoBrandOverlap.vue?vue&type=template&id=68630f76&scoped=true"
import script from "./CoBrandOverlap.vue?vue&type=script&lang=js"
export * from "./CoBrandOverlap.vue?vue&type=script&lang=js"

import "./CoBrandOverlap.vue?vue&type=style&index=0&id=68630f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68630f76"]])

export default __exports__